import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Col, Container, Row } from "react-grid-system";
import Button from "../../components/button";
import DialogContent from "../../components/dialog-content";
import DialogInfo from "../../components/dialog-info";
import { StyledContentManagement } from "../../containers/styles/StyledContentManagement";
import { Colors, Typography } from "../../themes";
import axios from "axios";
import AppConfig from "../../config.js";
import Example from "../../components/grid/index";
import { USER_TYPE } from "../../constants";
import PopupModal from "./popupModal.js";

const benefitsUrl = AppConfig.BENEFITS_URL;
const { Title } = Typography;

function ContentManagementPage({ account, history }) {
  const [dialogAddBanner, setDialogAddBanner] = useState(false);
  const [dialogEditBanner, setDialogEditBanner] = useState(false);
  const [type, setType] = useState("BANNER");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [id, setId] = useState("");
  const [text, setText] = useState("");
  const [url, setUrl] = useState("");
  const [image, setImage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [base64Image, setBase64Image] = useState("");
  const [contentData, setContentData] = useState([]);
  const [infoDialogShow, setInfoDialogShow] = useState(false);
  const [infoDescription, setInfoDescription] = useState("");
  const [showModalPopup, setShowModalPopup] = useState(false);
  const [selectedPopup, setSelectedPopup] = useState(null);

  const fetchBanners = () => {
    axios
      .get(`${benefitsUrl}/banners`, {
        params: {
          type,
        },
      })
      .then((res) => setContentData(res.data.payload?.data || []));
  };

  useEffect(() => {
    fetchBanners();
  }, [type]);

  const onChangeText = (name, value) => {
    switch (name) {
      case "title":
        setTitle(value);
        break;
      case "description":
        setDescription(value);
        break;
      case "text":
        setText(value);
        break;
      case "url":
        setUrl(value);
        break;
      case "buttonText":
        setButtonText(value);
        break;
      default:
        break;
    }
  };

  const onEditPopup = (popup) => {
    setSelectedPopup(popup);
    setShowModalPopup(true);
  };

  const showItemAfterEdit = () => {
    setTimeout(fetchBanners(), 500);
  };

  const onClickCreate = () => {
    axios
      .post(`${benefitsUrl}/banner`, {
        title,
        description,
        text,
        url,
        base64Image,
        buttonText,
      })
      .then((res) => {
        if (res.data.type === "ERROR") {
          const desc = res.data.error ? res.data.error : "Error";
          onDialogInfo(desc);
        } else {
          setDialogAddBanner(false);
          setTitle("");
          setDescription("");
          setId("");
          setText("");
          setUrl("");
          setImage("");
          setBase64Image("");
          setButtonText("");
        }
      })
      .catch((err) => {
        onDialogInfo(err);
      });
    showItemAfterEdit();
  };

  const onClickEdit = () => {
    axios
      .patch(`${benefitsUrl}/banner/${id}`, {
        title,
        description,
        text,
        url,
        base64Image,
        buttonText,
      })
      .then((res) => {
        if (res.data.type === "ERROR") {
          const desc = res.data.error ? res.data.error : "Error";
          onDialogInfo(desc);
        } else {
          setDialogAddBanner(false);
        }
      });
    axios.get(`${benefitsUrl}/banners`).then((res) => {
      setContentData(res.data.payload.data);
      setDialogEditBanner(false);
    });
    showItemAfterEdit();
  };

  const handleChangeI = (e) => {
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImage(URL.createObjectURL(file));
      setBase64Image(reader.result);
    };
  };

  const showItemAfterDelete = () => {
    setTimeout(fetchBanners, 500);
  };

  const onDelete = (deleteId) => {
    const confirmation = confirm("Are you sure want to delete this banner?");
    if (confirmation) {
      axios.delete(`${benefitsUrl}/banner/${deleteId}`).then((res) => {
        console.log(res);
      });
      showItemAfterDelete();
    }
  };

  const onDialogInfo = (desc) => {
    setInfoDescription(desc);
    setInfoDialogShow(true);
  };

  const onShowModalPopup = () => {
    setShowModalPopup(!showModalPopup);
    setSelectedPopup(null);
  };

  return (
    <StyledContentManagement>
      <DialogContent
        titleCreate={title}
        idCreate={id}
        urlCreate={url}
        textCreate={text}
        imageCreate={image}
        description={description}
        buttonText={buttonText}
        onClickCreate={onClickCreate}
        onChangeImageCreate={handleChangeI}
        onChangeText={onChangeText}
        dialogProps={{
          isVisible: dialogAddBanner,
          isClose: () => setDialogAddBanner(false),
        }}
      />

      <DialogInfo
        isVisible={infoDialogShow}
        textInfo={infoDescription}
        onOkButton={() => setInfoDialogShow(false)}
      />

      <div className="title-container">
        <Title customStyle={` color: black; padding:  `}>
          Content Management
        </Title>
        {account?.payload?.data?.account?.type &&
          account.payload.data.account.type !== USER_TYPE.VIEWER && (
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                backgroundColor={Colors.primaryBgColor}
                textColor={Colors.color11}
                borderColor={Colors.color11}
                text="Create Pop Up"
                buttonStyle={` width: 315px; zIndex: 100; border: 1.5px solid ${Colors.color11}`}
                textStyle={` font-weight: 800; `}
                onClick={() => setShowModalPopup(true)}
              />
              <Button
                text="Create New Banner"
                buttonStyle={` width: 315px; zIndex: 100`}
                textStyle={` font-weight: 800; `}
                onClick={() => setDialogAddBanner(true)}
              />
            </div>
          )}
      </div>

      <Container>
        <Row style={{ marginBottom: "30px" }}>
          <Col lg={3}>
            <Button
              text="Banners"
              backgroundColor={
                type === "BANNER" ? Colors.color10 : Colors.color9
              }
              textColor={type === "BANNER" ? undefined : Colors.color7}
              onClick={() => setType("BANNER")}
            />
          </Col>
          <Col lg={3}>
            <Button
              text="Pop Ups"
              backgroundColor={
                type === "POPUP" ? Colors.color10 : Colors.color9
              }
              textColor={type === "POPUP" ? undefined : Colors.color7}
              onClick={() => setType("POPUP")}
            />
          </Col>
        </Row>
        <Example
          bannerData={contentData}
          type={type}
          onEditPopup={onEditPopup}
        />
      </Container>
      {showModalPopup && (
        <PopupModal
          showModalPopup={showModalPopup}
          setShowModalPopup={onShowModalPopup}
          onDialogInfo={onDialogInfo}
          fetchBanners={fetchBanners}
          editData={selectedPopup}
        />
      )}
    </StyledContentManagement>
  );
}

const mapStateToProps = (state) => ({
  account: state.auth.account,
});

export default connect(mapStateToProps)(ContentManagementPage);
